import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaBox, FaCalendarAlt, FaMoneyBill, FaUserCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import Fotter from "./Fotter";
import Navbar from "./Navbar";

const AllOrdersPage = () => {
  const orders = [
    {
      orderId: "ORD12345",
      customer: "John Doe",
      date: "2025-04-18",
      totalAmount: "₹2,500",
      status: "Delivered",
      products: [
        { name: "Paracetamol", quantity: 2, price: "₹500" },
        { name: "Vitamin C", quantity: 1, price: "₹300" },
      ],
    },
    {
      orderId: "ORD12346",
      customer: "Priya Sharma",
      date: "2025-04-17",
      totalAmount: "₹1,200",
      status: "Shipped",
      products: [
        { name: "Blood Pressure Monitor", quantity: 1, price: "₹1,200" },
      ],
    },
    {
      orderId: "ORD12347",
      customer: "Amit Patel",
      date: "2025-04-15",
      totalAmount: "₹3,800",
      status: "Cancelled",
      products: [
        { name: "Insulin Kit", quantity: 1, price: "₹2,000" },
        { name: "Bandage Roll", quantity: 2, price: "₹900" },
      ],
    },
  ];

  const [filter, setFilter] = useState("All");
  const [expandedOrders, setExpandedOrders] = useState([]);

  const toggleDetails = (orderId) => {
    setExpandedOrders((prev) =>
      prev.includes(orderId) ? prev.filter((id) => id !== orderId) : [...prev, orderId]
    );
  };

  const filteredOrders = orders.filter((order) => {
    if (filter === "All") return true;
    if (filter === "Previous") return order.status === "Cancelled";
    if (filter === "Completed") return order.status === "Delivered";
    if (filter === "Shipped") return order.status === "Shipped";
    return false;
  });

  const filterLinks = ["All", "Previous", "Completed", "Shipped"];

  const styles = {
    page: {
      padding: "2rem",
      background: "linear-gradient(to right, #e0f7fa, #f1f8e9)",
      minHeight: "100vh",
      fontFamily: "'Poppins', sans-serif",
    },
    title: {
      fontSize: "2rem",
      fontWeight: "bold",
      marginBottom: "1rem",
      color: "#2c3e50",
      textAlign: "center",
    },
    linkBar: {
      display: "flex",
      justifyContent: "center",
      gap: "2rem",
      marginBottom: "2rem",
      flexWrap: "wrap",
    },
    link: (selected) => ({
      position: "relative",
      fontSize: "1.1rem",
      color: selected ? "#2980b9" : "#34495e",
      cursor: "pointer",
      fontWeight: selected ? "bold" : "normal",
      transition: "color 0.3s",
    }),
    underline: {
      position: "absolute",
      bottom: -5,
      left: 0,
      height: 3,
      width: "100%",
      backgroundColor: "#2980b9",
      borderRadius: 2,
    },
    orderList: {
      display: "flex",
      flexWrap: "wrap",
      gap: "2rem",
      justifyContent: "center",
    },
    card: {
      background: "#fff",
      padding: "1.5rem",
      borderRadius: "20px",
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      width: "300px",
      transition: "transform 0.3s ease",
    },
    item: {
      display: "flex",
      alignItems: "center",
      marginBottom: "0.8rem",
      fontSize: "1rem",
      color: "#34495e",
    },
    icon: {
      marginRight: "0.7rem",
      color: "#2980b9",
    },
    status: (status) => ({
      padding: "0.3rem 1rem",
      borderRadius: "20px",
      backgroundColor:
        status === "Delivered"
          ? "#2ecc71"
          : status === "Shipped"
          ? "#f39c12"
          : "#e74c3c",
      color: "white",
      fontWeight: "bold",
      textAlign: "center",
      marginTop: "1rem",
    }),
    moreBtn: {
      background: "none",
      border: "none",
      color: "#2980b9",
      cursor: "pointer",
      fontWeight: "bold",
      marginTop: "1rem",
      display: "flex",
      alignItems: "center",
    },
    productBox: {
      marginTop: "1rem",
      background: "#ecf0f1",
      borderRadius: "10px",
      padding: "0.7rem 1rem",
      fontSize: "0.95rem",
    },
  };

  return (
    <>
      <Navbar />
      <br /><br /><br /><br /><br /><br /><br />
      <div style={styles.page}>
        <div style={styles.title}>📦 All Your Orders</div>
        <div style={styles.linkBar}>
          {filterLinks.map((type) => (
            <div key={type} onClick={() => setFilter(type)} style={styles.link(filter === type)}>
              {type} Orders
              {filter === type && (
                <motion.div
                  layoutId="underline"
                  style={styles.underline}
                  transition={{ duration: 0.3 }}
                />
              )}
            </div>
          ))}
        </div>

        <div style={styles.orderList}>
          {filteredOrders.length > 0 ? (
            filteredOrders.map((order, index) => (
              <motion.div
                key={index}
                style={styles.card}
                whileHover={{ scale: 1.05, rotateY: 5 }}
                transition={{ type: "spring", stiffness: 100 }}
              >
                <div style={styles.item}>
                  <FaBox style={styles.icon} /> Order ID: {order.orderId}
                </div>
                <div style={styles.item}>
                  <FaUserCircle style={styles.icon} /> Customer: {order.customer}
                </div>
                <div style={styles.item}>
                  <FaCalendarAlt style={styles.icon} /> Date: {order.date}
                </div>
                <div style={styles.item}>
                  <FaMoneyBill style={styles.icon} /> Total: {order.totalAmount}
                </div>
                <div style={styles.status(order.status)}>{order.status}</div>

                <button style={styles.moreBtn} onClick={() => toggleDetails(order.orderId)}>
                  {expandedOrders.includes(order.orderId) ? (
                    <>
                      Hide Details <FaChevronUp style={{ marginLeft: "0.5rem" }} />
                    </>
                  ) : (
                    <>
                      More Details <FaChevronDown style={{ marginLeft: "0.5rem" }} />
                    </>
                  )}
                </button>

                <AnimatePresence>
                  {expandedOrders.includes(order.orderId) && (
                    <motion.div
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: "auto" }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{ duration: 0.4 }}
                    >
                      <div style={styles.productBox}>
                        <strong>Products:</strong>
                        <ul style={{ paddingLeft: "1rem" }}>
                          {order.products.map((product, i) => (
                            <li key={i}>
                              {product.name} — {product.quantity} × {product.price}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            ))
          ) : (
            <div style={{ fontSize: "1.2rem", color: "#7f8c8d" }}>
              No orders found for this category.
            </div>
          )}
        </div>
      </div>
      <Fotter />
    </>
  );
};

export default AllOrdersPage;
